module.exports = __webpack_public_path__ + "img/light.bd559801.jpg";